module.exports = __webpack_public_path__ + "media/customizations/wonderlandbyrunway/logo-new-540a115d1a5ba4ce1926a05bc3c7bb96.png";